import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { combineMediaQueriesWithAnd } from '@configuratorware/configurator-frontendgui/Utils/Styles/combineMediaQueries';
import FullScreenView, { PreviewButton } from '../../../../Screens/Configurator/Components/FullScreenView';

const getHeight = (theme, orientation) => {
  const isLandscape = document.documentElement.clientWidth > document.documentElement.clientHeight;

  if (orientation === 'landscape') {
    if (isLandscape) return document.querySelector('#root').getBoundingClientRect().height;
    return document.querySelector('#root').getBoundingClientRect().width;
  }
  if (isLandscape) return document.querySelector('#root').getBoundingClientRect().width;
  return document.querySelector('#root').getBoundingClientRect().height;
};

export const useStyles = makeStyles(
  (theme) => ({
    viewsContainer: {
      width: '100%',
      '@media (max-height: 650px)': {
        bottom: 0,
      },
      [theme.breakpoints.up('sm')]: {
      },
    },
    button: {
      [theme.breakpoints.down('sm')]: {
        bottom: 'auto',
      },
    },
    thumbnailDots: {
    },
    thumbnailGrid: {
      marginBottom: '7vh', // \(getHeight(theme, "portrait")  -166-theme.layout.footerbar.heightSm *3)/2 - 58 *1.5 ,
      [theme.orientation.landscape]: {
        marginBottom: '7vh', // \(getHeight(theme, "landscape")  -166-theme.layout.footerbar.heightSm *3)/2 - 58*2 ,
      },
      width: '100%',
      maxWidth: '100%',
      left: 0,
      transform: 'revert',
      padding: `${theme.spacing(2)}px 0px`,
      [theme.breakpoints.up('sm')]: {
        marginBottom: '23vh', // \(getHeight(theme, "portrait")-194-theme.layout.footerbar.height)/2 - 58*2 ,
        [theme.orientation.landscape]: {
          marginBottom: '16vh', // \(getHeight(theme, "landscape")-194-theme.layout.footerbar.height)/2 - 58*2  ,
        },
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
        left: 0,
      },
      [combineMediaQueriesWithAnd(theme.orientation.portrait, theme.breakpoints.down('md'))]: {
        maxWidth: '100%',
        width: '100%',
      },
      // styles for ipad pro
      [combineMediaQueriesWithAnd(theme.orientation.portrait, theme.breakpoints.up('md'))]: {
        bottom: 20,
      },
      [theme.orientation.portrait]: {
        maxWidth: '100%',
        width: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
  }),
  { name: 'CreatorFullScreenView' },
);
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default (props) => {
  const { thumbnailDots, ...classes } = useStyles(props);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <FullScreenView
      classes={windowDimensions ? classes : classes}
      thumbnailProps={{
        classes: {
          dots: thumbnailDots,
        },
      }}
      {...props}
    />
  );
};
